module.exports = __webpack_public_path__ + "img/reviewer3.377f1c7b.png";